<script>
export default {
  name: "condusef-product-form",
  props: {
    variant: {
      type: String,
      default: 'redeco'
    },
    for: {
      type: String,
      default: 'for_complaints'
    }
  },
  data: () => ({
    products: [],
    causes: [],
    form: {
      product: null,
      causaId: null
    }
  }),
  watch: {
    form: {
      deep: true,
      handler(val) {
        this.$emit('onChange', val);
      }
    },
    'form.product': function (val) {
      this.fetchCauses(val)
    },
  },
  async mounted() {
    await this.fetchProducts();
  },
  methods: {
    async fetchProducts() {
      this.$vs.loading();
      try {
        const {data} = await axios.get(`/api/condusef/${this.variant}/products`);
        this.products = data;
      } catch (e) {
        console.error(e);
      } finally {
        this.$vs.loading.close();
      }
    },
    async fetchCauses(productId) {
      this.$vs.loading();
      try {
        const {data} = await axios.get(`/api/condusef/${this.variant}/causes?productId=${productId}&for=${this.for}`);
        this.causes = data;
      } catch (e) {
        console.error(e);
      } finally {
        this.$vs.loading.close();
      }
    },
  }
}
</script>

<template>
  <vx-card title="Productos y causas">
    <div class="mt-2">
      <label>Producto</label>
      <v-select
          label="product"
          class="vs-custom w-full mb-4"
          v-model.lazy="form.product"
          :options="products"
          :reduce="product => product.productId"
          :clearable="false"
          :searchable="true"
          placeholder="Seleccione una opción">
        <div slot="no-options">No hay coincidencias</div>
      </v-select>
    </div>
    <div v-if="form.product !== null">
      <label>Causa</label>
      <v-select
          label="causa"
          class="vs-custom w-full mb-4"
          v-model.lazy="form.causaId"
          :options="causes"
          :reduce="cause => cause.causaId"
          :clearable="false"
          :searchable="true"
          placeholder="Seleccione una opción">
        <div slot="no-options">No hay coincidencias</div>
      </v-select>
    </div>
  </vx-card>
</template>